import currencyformat, { symbols } from 'currencyformatter.js';

const CURRENCY = {
  GBP: 'GBP',
  AED: 'AED',
  AUD: 'AUD',
  CNY: 'CNY',
  EUR: 'EUR',
  USD: 'USD',
};

function CurrencyFormatter(value: any, currency: string | undefined | null, locale: string = 'en') {
  if (!currency) {
    return;
  }
  return currencyformat.format(value, { currency, locale });
}

function useGetCurrencySymbol(currency: string | undefined | null) {
  if (!currency) return '';
  return symbols[currency?.toUpperCase()];
}
export { CURRENCY, useGetCurrencySymbol };

export default CurrencyFormatter;
